import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Illustration from 'features/klarnaMarketing/view/components/core/Illustration';
import Block from 'features/searchCompare/modules/klarnaMarketing/web-components/modules/components/Block';
import styled from 'styled-components';
import Typography from '../../../elements/components/Typography';
const ContentWrapper = styled.div.withConfig({
    componentId: "sc-39a18d-0"
})([
    `width:100%;max-width:800px;margin:0 auto;`
]);
const Separator = styled.div.withConfig({
    componentId: "sc-39a18d-1"
})([
    `display:flex;justify-content:center;align-items:center;gap:`,
    `;width:100%;padding:16px 0 32px 0;`
], ({ $labelAlignment })=>$labelAlignment === 'left' ? '8px' : '16px');
const Line = styled.div.withConfig({
    componentId: "sc-39a18d-2"
})([
    `width:auto;height:1px;background:`,
    `;flex-grow:1;`
], ({ theme, $inverse })=>$inverse ? theme.colors.background.inverse : 'rgba(11, 5, 29, 0.64)');
const SeparatorLabel = styled.div.withConfig({
    componentId: "sc-39a18d-3"
})([
    `line-height:145%;letter-spacing:-0.003em;`
]);
const LeftLine = styled(Line).withConfig({
    componentId: "sc-39a18d-4"
})([
    `width:`,
    `;flex-grow:`,
    `;`
], ({ $labelAlignment })=>$labelAlignment === 'left' ? '45px' : 'auto', ({ $labelAlignment })=>$labelAlignment === 'left' ? '0' : '1');
const MainContent = styled.div.withConfig({
    componentId: "sc-39a18d-5"
})([
    `display:flex;align-items:flex-start;gap:9px;`,
    `;`
], ({ $margin })=>$margin && `margin: ${$margin}`);
const IconContainer = styled.div.withConfig({
    componentId: "sc-39a18d-6"
})([
    `padding:4px 0 0;width:45px;`
]);
const TextContainer = styled.div.withConfig({
    componentId: "sc-39a18d-7"
})([
    `display:flex;flex-direction:column;align-items:flex-start;gap:5px;`,
    ``
], ({ $contentBorder })=>$contentBorder && `
    border: 1px solid black; 
    table {
      margin: -1px;
    }
  `);
const Title = styled(Typography).withConfig({
    componentId: "sc-39a18d-8"
})([
    ``,
    `;`
], ({ $margin })=>$margin && `margin: ${$margin}`);
const DisclaimerBlock = ({ label, labelAlignment = 'center', title, text, icon, inverse, background, contentBorder })=>{
    return /*#__PURE__*/ _jsx(Block, {
        center: true,
        noPaddingTop: true,
        background: background,
        inverse: inverse,
        noPaddingBottom: !label,
        children: /*#__PURE__*/ _jsxs(ContentWrapper, {
            children: [
                label && /*#__PURE__*/ _jsxs(Separator, {
                    $labelAlignment: labelAlignment,
                    children: [
                        /*#__PURE__*/ _jsx(LeftLine, {
                            $inverse: inverse,
                            $labelAlignment: labelAlignment
                        }),
                        /*#__PURE__*/ _jsx(SeparatorLabel, {
                            $inverse: inverse,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                noWrap: true,
                                variant: "small",
                                children: label
                            })
                        }),
                        /*#__PURE__*/ _jsx(Line, {
                            $inverse: inverse
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(MainContent, {
                    $margin: label ? '0' : '24px 0',
                    children: [
                        icon && /*#__PURE__*/ _jsx(IconContainer, {
                            children: /*#__PURE__*/ _jsx(Illustration, {
                                name: icon
                            })
                        }),
                        /*#__PURE__*/ _jsxs(TextContainer, {
                            $contentBorder: contentBorder,
                            children: [
                                title && /*#__PURE__*/ _jsx(Title, {
                                    $margin: contentBorder ? '4px 0 4px' : '',
                                    variant: "small",
                                    weight: "medium",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "small",
                                    children: text
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default DisclaimerBlock;
